<app-header></app-header>

<section style="margin-top:110px">
  <div class="blog-layout">

    <!-- Left: Big Card -->
    <div class="blog-left">
      <div class="blog-card big" [routerLink]="['/blog-detail', blogData[0]?._id]" style="cursor:pointer;">
        <img [src]="BaseUrl + '/' + blogData[0]?.image" alt="Pi Network Thumbnail">
        <div class="blog-content">
          <h3 class="blog-title">{{ blogData[0]?.mainTitle }}</h3>
          <p class="blog-snippet">{{ blogData[0]?.mainParagraph }}</p>
          <p class="blog-snippet"><span>{{ blogData[0]?.createdAt | date: 'mediumDate' }}</span></p>
        </div>
      </div>
    </div>

    <!-- Right Cards -->
    <div class="blog-right">  

      <div class="blog-card small" *ngFor="let blog of blogData?.slice(1, 3)" [routerLink]="['/blog-detail', blog?._id]" style="cursor:pointer;">
        <img [src]="BaseUrl + '/' + blog?.image" alt="{{ blog?.mainTitle }}" />
        <div class="blog-content">
          <h3 class="blog-title">{{ blog?.mainTitle }}</h3>
          <p class="excerpt">{{ blog?.mainParagraph }}</p>
        </div>
      </div>

    </div>
  </div>

  <br><br>

  <!-- Blog Grid -->  
  <div class="blog-grid">
    <a class="blog-post" *ngFor="let blog of blogData?.slice(1)" [routerLink]="['/blog-detail', blog?._id]">
      <img [src]="BaseUrl + '/' + blog?.image" [alt]="blog?.mainTitle + ' Thumbnail'">
      <div class="blog-content">
        <h3 class="title">{{ blog?.mainTitle }}</h3>
        <p class="excerpt">{{ blog?.mainParagraph }}</p>
        <div class="meta">
          <span>{{ blog?.createdAt | date: 'mediumDate' }}</span>
        </div>
      </div>
    </a>
  </div>
</section>

<section style="margin-top:320px">
  <app-footer></app-footer>
</section>
